var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGuinea(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_500)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.9568 1.24402C24.7901 0.440032 22.4466 -4.57764e-05 20.0001 -4.57764e-05C17.5538 -4.57764e-05 15.2104 0.440032 13.0438 1.24386L12.1742 20L13.0437 38.756C15.2104 39.56 17.5538 40 20.0001 40C22.4467 40 24.7901 39.56 26.9568 38.7559L27.8264 20L26.9568 1.24402Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 19.9999C0 28.5991 5.4275 35.9301 13.0435 38.7558V1.2438C5.4275 4.06974 0 11.4005 0 19.9999Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0001 19.9999C40.0001 11.4005 34.5726 4.06974 26.9565 1.2438V38.7559C34.5726 35.9301 40.0001 28.5991 40.0001 19.9999Z",
    fill: "#6DA544"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_500"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuinea);
export default __webpack_public_path__ + "static/media/guinea.7d0cf723480225d85f81fcab18e1a494.svg";
export { ForwardRef as ReactComponent };